import { gql } from "@apollo/client"

export const ADD_ORG_CLASS = gql`
  mutation addOrgClass($data: AddOrgClassRequest) {
    addOrgClass(data: $data)
  }
`

export const EDIT_ORG_CLASS = gql`
  mutation editOrgClass($data: EditOrgClassRequest) {
    editOrgClass(data: $data)
  }
`

export const DELETE_ORG_CLASS = gql`
  mutation deleteOrgClass($data: DeleteOrgClassRequest) {
    deleteOrgClass(data: $data)
  }
`

export const DELETE_ORG_CLASSES = gql`
  mutation deleteOrgClasses($data: DeleteOrgClassesRequest) {
    deleteOrgClasses(data: $data)
  }
`

export const UNDELETE_ORG_CLASS = gql`
  mutation undeleteOrgClass($data: UndeleteOrgClassRequest) {
    undeleteOrgClass(data: $data)
  }
`

export const ASSIGN_STUDENTS_TO_ORG_CLASS = gql`
  mutation assignStudentsToOrgClass($data: AssignStudentsToClassRequest) {
    assignStudentsToOrgClass(data: $data)
  }
`
